var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 15,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(-180 21 15)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95705 4.46742L13.2728 5.01689C13.713 5.07294 14.1216 5.27546 14.4327 5.59188C14.7963 5.96162 15 6.45939 15 6.97793L15 13.2695C15 14.03 14.6295 14.7429 14.0071 15.1799C13.6299 15.4448 13.3395 15.8155 13.1726 16.2452L12.1947 18.7632C12.1602 18.852 12.1192 18.9381 12.072 19.0209L12.0194 19.1132C11.7071 19.6615 11.1247 20 10.4937 20C9.32019 20 8.47693 18.8711 8.80991 17.7458L9.61225 15.0344L5.45674 15.0344C4.18905 15.0344 3.24118 13.8701 3.49832 12.6288L4.53502 7.62404C4.95871 5.57862 6.88494 4.20361 8.95705 4.46742Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs_down.bd3c93c5f13135da7b5ecfba61342ac1.svg";
export { ForwardRef as ReactComponent };